import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ num, title, sub, dark = false, testid }) => (
  <div className="mb-12 md:mb-16">
    <Reveal>
      <div className="flex items-center gap-4">
        <span
          className={`text-sm font-extrabold tracking-[0.3em] ${dark ? "text-white/40" : "text-primary/40"}`}
          data-testid={`section-number-${num}`}
        >
          {num}
        </span>
        <span className={`h-px flex-1 ${dark ? "bg-white/15" : "bg-primary/15"}`} />
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        data-testid={testid}
        className={`mt-6 text-4xl font-extrabold tracking-tighter sm:text-5xl ${dark ? "text-white" : "text-primary"}`}
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.14}>
        <p className={`mt-4 max-w-xl text-base leading-relaxed md:text-lg ${dark ? "text-white/70" : "text-muted-foreground"}`}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
